import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AbstractControlDirective } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'shared-ui-error-message',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent {
  control = input.required<AbstractControlDirective>();
  errorPath = input<string>('');

  stateVersion = input<number>(1);

  private errorPathPrefix = computed(() => {
    const path = this.errorPath();
    return path ? path + '.' : '';
  });

  errors = computed(() => {
    const stateVersion = this.stateVersion();
    const ctrl = this.control();

    if (!ctrl) return [];
    const shouldShow = (ctrl.dirty || ctrl.touched) && stateVersion;

    if (!shouldShow || !ctrl.invalid || !ctrl.errors) return [];

    const prefix = this.errorPathPrefix();
    const errors = { ...ctrl.errors };

    if (errors['errors']) {
      return errors['errors'].map((error: any) => ({ key: `${prefix}${error}`, params: null }));
    }
    if (errors['message']) {
      return [{ key: `${prefix}${errors['message']}`, params: null }];
    }
    return Object.keys(errors).map((key) => ({
      key: this.getKeyForDefaultErrors(key, prefix),
      params: errors[key],
    }));
  });

  private getKeyForDefaultErrors(key: string, prefix: string): string {
    const ctrl = this.control();
    const path = ctrl.path?.length ? ctrl.path.slice(-1)[0] : '';
    return `${prefix}${key}${prefix ? this.capitalize(path) : ''}`;
  }

  private capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
}
